export class PerfisMaster {
  private static readonly MASTER = ['Imap', 'Nti', 'SIGEM'];

  static isMaster(perfilNome?: string | null): boolean {
    if (!perfilNome) {
      return false;
    }

    return this.MASTER.some(
      p => p.toLowerCase() === perfilNome.toLowerCase()
    );
  }
}
